import React, { Component } from 'react';
import {
  string, func, bool, node,
} from 'prop-types';
import Modal from './Modal';

export default class ConfirmationModal extends Component {
  static propTypes = {
    isActive: bool.isRequired,
    title: string.isRequired,
    handleClose: func.isRequired,
    handleSubmit: func.isRequired,
    children: node.isRequired,
  };

  render() {
    return (
      <Modal
        isActive={this.props.isActive}
        title={this.props.title}
        onClose={this.props.handleClose}
      >
        {this.props.children}
        <br />
        <br />
        <div className="field is-grouped is-grouped-centered">
          <div className="control">
            <button className="button" onClick={this.props.handleClose}>
              <span className="icon is-small">
                <i className="mi mi-arrow-back" />
              </span>
              <span>Annulla</span>
            </button>
          </div>
          <div className="control">
            <button
              className="button is-success"
              onClick={this.props.handleSubmit}
            >
              <span className="icon is-small">
                <i className="mi mi-save" />
              </span>
              <span>Conferma</span>
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

ConfirmationModal.displayName = 'ConfirmationModal';
